import styled from "styled-components"

export const TagWrapper = styled.div`
  width: 940px;
  max-width: 100%;
  margin: 0 auto;
  padding: 15px 10px 15px 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 1400px) {
    padding: 10px 10px 12px 10px;
  }
  @media (max-width: 1200px) {
    padding: 10px 10px 10px 10px;
  }
  @media (max-width: 990px) {
    padding: 10px 25px 8px 25px;
  }
  @media (max-width: 575px) {
    padding: 10px 25px 8px 25px;
    text-align: center;
  }
`

export const Tooltip = styled.div`
  position: absolute;
  background-color: #fff;
  pointer-events: none;
  padding: 0.4rem 0.8rem;
  border-radius: 3px;
  color: #333;
  font-size: 13px;
  bottom: 90%;
  left: 50%;
  opacity: 0;
  white-space: wrap;
  width: 200px;
  visibility: hidden;
  z-index: 999;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  transform: translate3d(-50%, 0, 0);
  transition: 0.35s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid #fff;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
  }
`

export const SingleTagStyle = styled.div`
margin-top: 8px;
a{
  cursor:pointer;
  color:white !important;
  background-color: #4F80F0 !important;
  font-family:Trebuchet MS;
  font-size:16px;
  font-weight:bold;
  margin: 2px
  border-radius: 5px;
  padding: 3px
}
`
